import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { activateFamily, fetchFamilyById } from "../../service/FamilyApi";
import { useForm } from "react-hook-form";
import { Helmet } from "react-helmet-async";
import { Navbar, Footer, Loading, Breadcrumbs } from "../../components/shared";
import { useCheckAccess, maskAadhar } from "../../utils/Utilities";
import { customGroups } from '../general/DropDownValuesConfig';
function FamilyActivate() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [familyData, setFamilyData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [familyMembersAadhar, setFamilyMembersAadhar] = useState([]);
  const [error, setError] = useState(null);
  useCheckAccess('FamilyRW');

  const { register, handleSubmit, formState: { errors }, trigger, clearErrors, watch, setValue } = useForm();

  useEffect(() => {
    const fetchFamilyData = async () => {
      try {
        if (id) {
          const data = await fetchFamilyById(id);
          setFamilyData(data);
        }
      } catch (error) {
        setError("குடும்பத் தகவலை பெறுவதில் பிழை ஏற்பட்டது");
      }
    };

    fetchFamilyData(); // Call the async function inside useEffect
  }, [id]); // Only re-run if id changes

  // When family data is updated, extract family member Aadhar numbers
  useEffect(() => {
    if (familyData && familyData.family.familyMembers) {
      const aadharNumbers = familyData.family.familyMembers
        .filter(member => member.status !== 'inactive')  // Filter out inactive members
        .map(member => member.aadhar); // Get the aadhar numbers of active members
      setFamilyMembersAadhar(aadharNumbers);  // Set the filtered aadhar numbers

      // Set form default values, ensure id and familyHeadAadhar are set correctly
      setValue("id", String(familyData.family.id));  // Ensure id is set as a string
      setValue("kootamName", familyData.family.kootamName);
      setValue("customGroup", familyData.family.customGroup || "");
      setValue("familyHeadAadhar", familyData.family.familyHeadAadhar);  // Set the familyHeadAadhar correctly
      setValue("status", familyData.family.status);
      setValue("familyName", familyData.family.familyName || "");
    }
  }, [familyData, setValue]);

  const handleChange = async (fieldName) => {
    await trigger(fieldName); // Trigger field validation
    clearErrors(fieldName); // Clear error if valid
  };

  // Validate Aadhar number based on existing family member Aadhar numbers
  const validateAadhar = (value) => {
    if (!familyMembersAadhar.includes(value)) {
      return "ஆதார் எண்ணு குடும்ப உறுப்பினரிடமிருந்து தேர்ந்தெடுக்கப்பட வேண்டும்";
    }
    return true;
  };

  // Handle form submission (API update)
  const onSubmit = async (data) => {
    if (loading) {
      return;  // Prevent form submission if loading is true
    }

    setLoading(true);
    if (
      data.familyHeadAadhar &&
      (data.familyHeadAadhar.startsWith("TMP") || data.familyHeadAadhar.startsWith("00")) &&
      data.status === "active"
    ) {
      data.status = "draft";
      alert("ஆதார் விவரங்கள் முடிவடையாததால், நிலையை 'active' மாற்ற முடியாது");
      return;
    }


    // Explicitly convert the `id` to string before sending to API
    const familyId = String(familyData.family.id);

    // Only update if something has changed
    if (
      data.kootamName !== familyData.family.kootamName ||
      data.customGroup !== familyData.family.customGroup ||
      data.familyName !== familyData.family.familyName ||
      data.familyHeadAadhar !== familyData.family.familyHeadAadhar ||
      data.status !== familyData.family.status
    ) {

      // Prepare the final data object to send to the API
      const payload = {
        ...data, // Spread the existing form data
      };


      try {
        const response = await activateFamily(payload, familyId);
        if (response) {
          navigate(`/family/view/${response.newFamilyId}`);
        }
      } catch (error) {
        console.error("குடும்பத்தை புதுப்பிக்க இயலவில்லை:", error);
      } finally {
        setLoading(false);
      }
    }
  };


  if (!familyData) {
    return (
      <>
        <Navbar />
        <div className="general_parent">
          <div className="general_container">
            <div className="general_body">
              <Breadcrumbs /><br />
              <Loading />
            </div>
          </div>
        </div>
        <Footer />
      </>
    );
  }
  if (error) {
    return <div>Error: {error}</div>; // Display error message
  }
  return (
    <>
      <Navbar />
      <Helmet>
        <title>குடும்பத்தை செயல்படுத்து</title>
        <link rel="canonical" href={`/family/update/${id}`} />
      </Helmet>

      <div className="general_parent">
        <div className="general_container">
          <div className="general_body">
            <Breadcrumbs /><br />
            <h3>குடும்பத்தை செயல்படுத்து</h3>
            <br />
            <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
              <input
                type="hidden"
                {...register("id")} // Register the id field so it is included in the form data
                value={familyData.family.id}  // Set the value of the id field from the family data
              />
              <div className="details-card">
                <div className="detail-item">
                  <span className="detail-label"><strong>குடும்ப எண் :</strong></span>
                  <span className="detail-value">{familyData.family.id || ""}</span>
                </div>
                <div className="detail-item">
                  <span className="detail-label"><strong>தற்போதைய குடும்பத் தலைவர் ஆதார்:</strong></span>
                  <span className="detail-value">{maskAadhar(familyData.family.maskedFamilyHeadAadhar) || ""}</span>
                </div>
                <div className="detail-item">
                  <span className="detail-label"><strong>தற்போதைய நிலை:</strong></span>
                  <span className="detail-value">{familyData.family.status || ""}</span>
                </div>

                <div className="detail-item">
                  <span className="detail-label"><strong>குடும்பப் பெயர்:</strong></span>
                  <div className="auth_element">
                    <input
                      type="text"
                      id="familyName"
                      {...register("familyName", {
                        pattern: { value: /^[A-Za-z\u0B80-\u0BFF\s.]*$/, message: "எழுத்துக்கள், இடைவெளிகள் மற்றும் '.' மட்டும் அனுமதிக்கப்படும்" },
                        minLength: { value: 2, message: "குறைந்தது 2 எழுத்துகள் வேண்டும்" },
                      })}
                      className="auth_input"
                      onChange={() => handleChange("familyName")}
                    />
                  </div>
                  {errors.familyName && <div className="auth_error">❗ {errors.familyName.message}</div>}
                </div>

                <div className="detail-item">
                  <span className="detail-label"><strong>கூட்டம்:</strong></span>
                  <div className="auth_element">
                    <select
                      id="kootamName"
                      {...register("kootamName", { required: "கூட்டம் தேர்வு செய்ய வேண்டும்" })}
                      className="auth_select"
                    >
                      <option value="">-- ஒரு கூட்டத்தைத் தேர்ந்தெடுக்கவும் --</option>
                      <option value="செம்பூத்தான்">செம்பூத்தான்</option>
                      <option value="மணியன்">மணியன்</option>
                      <option value="முத்தன்">முத்தன்</option>
                      <option value="பிற">பிற (கூட்டம்)</option>
                    </select>
                    {errors.kootamName && <div className="auth_error">❗ {errors.kootamName.message}</div>}

                    {/* Custom Group Dropdown */}
                    {watch("kootamName") === "பிற" && (
                      <div className="auth_element">
                        <label className="auth_label">பிற (கூட்டம்)</label>
                        <select
                          id="customGroup"
                          {...register("customGroup", {
                            required: "பிற (கூட்டம்) தேவை",
                          })}
                          className="auth_select"
                        >
                          <option value="">-- தேர்ந்தெடுக்கவும் --</option>
                          {customGroups.map((group) => (
                            <option key={group.value} value={group.value}>
                              {group.label}
                            </option>
                          ))}
                        </select>
                        {errors.customGroup && <div className="auth_error">❗ {errors.customGroup.message}</div>}
                      </div>
                    )}

                  </div>
                </div>
                <div className="detail-item">
                  <span className="detail-label"><strong>தற்போதைய பிற குழு:</strong></span>
                  <span className="detail-value">{familyData.family.customGroup || ""}</span>
                </div>

                <div className="detail-item">
                  <span className="detail-label"><strong>குடும்பத் தலைவர் ஆதார்:</strong></span>
                  <div className="auth_element">
                    <select
                      id="familyHeadAadhar"
                      {...register("familyHeadAadhar", {
                        required: "ஆதார் எண்ணு தேவை",
                        validate: validateAadhar
                      })}
                      className="auth_select"
                      value={watch("familyHeadAadhar")}
                    >
                      <option value="">ஆதார் எண்ணைத் தேர்ந்தெடுக்கவும்</option>
                      {familyData.family.familyMembers
                        .filter((member) => /^\d{12}$/.test(member.maskedAadhar)) // Only valid Aadhaar
                        .map((member) => (
                          <option key={member.aadhar} value={member.aadhar}>
                            {member.firstName} {member.lastName} ({maskAadhar(member.maskedAadhar)})
                          </option>
                        ))}
                    </select>
                    {errors.familyHeadAadhar && <div className="auth_error">❗ {errors.familyHeadAadhar.message}</div>}
                  </div>
                </div>

                <div className="detail-item">
                  <span className="detail-label"><strong>நிலை:</strong></span>
                  <div className="auth_radio">
                    <label className="auth_radio-label">
                      <input
                        type="radio"
                        value="active"
                        {...register("status", { required: "நிலை தேவை" })}
                        defaultChecked={familyData.family.status === "active"}
                      />
                      ✅ active
                    </label>
                    <label className="auth_radio-label">
                      <input
                        type="radio"
                        value="inactive"
                        {...register("status", { required: "நிலை தேவை" })}
                        defaultChecked={familyData.family.status === "inactive"}
                      />
                      ❌  inactive
                    </label>
                    <label className="auth_radio-label">
                      <input
                        type="radio"
                        value="draft"
                        {...register("status", { required: "நிலை is required" })}
                        defaultChecked={familyData.family.status === "draft"}
                      />
                      📝 draft
                    </label>
                    <label className="auth_radio-label">
                      <input
                        type="radio"
                        value="pending"
                        {...register("status", { required: "நிலை is required" })}
                      />
                      ⚠️⏳ pending (Applied by public)
                    </label>
                    {errors.status && <div className="auth_error">❗ {errors.status.message}</div>}
                  </div>
                </div>

                <button type="submit" className="auth_submit" disabled={loading}>சமர்ப்பிக்கவும்</button>
                <br />
              </div>
            </form>
            <button onClick={() => navigate(`/family/member-create/${id}`)}>குடும்ப உறுப்பினரைச் சேர்</button>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
}

export default FamilyActivate;
